// ... existing moving average functions ...

export function arima(
  data: number[],
  p: number = 1, // AR order
  d: number = 0, // Difference order
  q: number = 1, // MA order
): number[] {
  // First apply differencing
  let diffed = data;
  for (let i = 0; i < d; i++) {
    diffed = difference(diffed);
  }

  // AR component - use previous p values
  const ar = (i: number): number => {
    let sum = 0;
    for (let j = 1; j <= p; j++) {
      if (i - j >= 0) {
        sum += 0.7 * diffed[i - j]; // Using 0.7 as a simple AR coefficient
      }
    }
    return sum;
  };

  // MA component - use previous q errors
  const errors: number[] = [];
  const ma = (i: number): number => {
    let sum = 0;
    for (let j = 1; j <= q; j++) {
      if (i - j >= 0) {
        sum += 0.3 * errors[i - j]; // Using 0.3 as a simple MA coefficient
      }
    }
    return sum;
  };

  // Generate forecasts
  const result: number[] = [];
  for (let i = 0; i < diffed.length; i++) {
    const forecast = ar(i) + ma(i);
    const error = diffed[i] - forecast;
    errors.push(error);
    result.push(forecast);
  }

  // Reverse differencing
  let final = result;
  for (let i = 0; i < d; i++) {
    final = undifference(final, data);
  }

  return final;
}

// Helper function to compute differences
function difference(data: number[]): number[] {
  const result: number[] = [];
  for (let i = 1; i < data.length; i++) {
    result.push(data[i] - data[i - 1]);
  }
  return result;
}

// Helper function to reverse differencing
function undifference(diffed: number[], original: number[]): number[] {
  const result: number[] = [original[0]];
  for (let i = 0; i < diffed.length; i++) {
    result.push(result[i] + diffed[i]);
  }
  return result;
}
